import { render, staticRenderFns } from "./ModalWindowFooter.vue?vue&type=template&id=3bbd18de&scoped=true&"
import script from "./ModalWindowFooter.vue?vue&type=script&lang=ts&"
export * from "./ModalWindowFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWindowFooter.vue?vue&type=style&index=0&id=3bbd18de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd18de",
  null
  
)

export default component.exports